/* eslint-disable @typescript-eslint/no-namespace, @typescript-eslint/array-type, @typescript-eslint/no-explicit-any, @typescript-eslint/ban-types, @typescript-eslint/consistent-indexed-object-style, @typescript-eslint/no-redundant-type-constituents */
// @ts-nocheck
// THIS FILE IS GENERATED, DO NOT EDIT!
import type * as Types from './types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type InitiateMessengerAuthMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type InitiateMessengerAuthMutation = { __typename?: 'Mutation', initiateMessengerAuth: { __typename?: 'GetChatTokenConfigResponse', token: string, config: { __typename?: 'ChatConfigurationModel', base_url: string, dev_server: string, host: string, conference: string } } };

export type GetChatRoomQueryVariables = Types.Exact<{
  input: Types.GetChatRoomInput;
}>;


export type GetChatRoomQuery = { __typename?: 'Query', getChatRoom: { __typename?: 'ChatRoomModel', name: string } };


export const InitiateMessengerAuthDocument = gql`
    mutation initiateMessengerAuth {
  initiateMessengerAuth {
    token
    config {
      base_url
      dev_server
      host
      conference
    }
  }
}
    `;
export type InitiateMessengerAuthMutationFn = Apollo.MutationFunction<InitiateMessengerAuthMutation, InitiateMessengerAuthMutationVariables>;
export function useInitiateMessengerAuthMutation(baseOptions?: Apollo.MutationHookOptions<InitiateMessengerAuthMutation, InitiateMessengerAuthMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitiateMessengerAuthMutation, InitiateMessengerAuthMutationVariables>(InitiateMessengerAuthDocument, options);
      }
export type InitiateMessengerAuthMutationHookResult = ReturnType<typeof useInitiateMessengerAuthMutation>;
export type InitiateMessengerAuthMutationResult = Apollo.MutationResult<InitiateMessengerAuthMutation>;
export type InitiateMessengerAuthMutationOptions = Apollo.BaseMutationOptions<InitiateMessengerAuthMutation, InitiateMessengerAuthMutationVariables>;
export const GetChatRoomDocument = gql`
    query getChatRoom($input: GetChatRoomInput!) {
  getChatRoom(input: $input) {
    name
  }
}
    `;
export function useGetChatRoomQuery(baseOptions: Apollo.QueryHookOptions<GetChatRoomQuery, GetChatRoomQueryVariables> & ({ variables: GetChatRoomQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChatRoomQuery, GetChatRoomQueryVariables>(GetChatRoomDocument, options);
      }
export function useGetChatRoomLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChatRoomQuery, GetChatRoomQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChatRoomQuery, GetChatRoomQueryVariables>(GetChatRoomDocument, options);
        }
// @ts-ignore
export function useGetChatRoomSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetChatRoomQuery, GetChatRoomQueryVariables>): Apollo.UseSuspenseQueryResult<GetChatRoomQuery, GetChatRoomQueryVariables>;
export function useGetChatRoomSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetChatRoomQuery, GetChatRoomQueryVariables>): Apollo.UseSuspenseQueryResult<GetChatRoomQuery | undefined, GetChatRoomQueryVariables>;
export function useGetChatRoomSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetChatRoomQuery, GetChatRoomQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetChatRoomQuery, GetChatRoomQueryVariables>(GetChatRoomDocument, options);
        }
export type GetChatRoomQueryHookResult = ReturnType<typeof useGetChatRoomQuery>;
export type GetChatRoomLazyQueryHookResult = ReturnType<typeof useGetChatRoomLazyQuery>;
export type GetChatRoomSuspenseQueryHookResult = ReturnType<typeof useGetChatRoomSuspenseQuery>;
export type GetChatRoomQueryResult = Apollo.QueryResult<GetChatRoomQuery, GetChatRoomQueryVariables>;
import { withMutationResponseHandler, withQueryResponseHandler } from '../hooks/useResponseHandler';
export const useGetChatRoom = withQueryResponseHandler(useGetChatRoomQuery);
export const useInitiateMessengerAuth = withMutationResponseHandler(useInitiateMessengerAuthMutation, "initiateMessengerAuth");